module.exports = __webpack_public_path__ + "media/styleguide/icons/pro-star-f2c91e72fdb8c0de8de241fd973c2425.svg";